import { render } from "./PrinterSettings.vue?vue&type=template&id=63502c10"
import script from "./PrinterSettings.vue?vue&type=script&lang=js"
export * from "./PrinterSettings.vue?vue&type=script&lang=js"

import "./PrinterSettings.vue?vue&type=style&index=0&id=63502c10&lang=scss"
script.render = render

export default script